export default `vec3 Q = abs(mod(p,1.8)-.9);
    float a=3.;
    float d = 1.;
    for(int j=0;j++<9;)
      Q=2.*clamp(Q,-.9,.9)-Q,
      d=dot(Q,Q),
      Q/=d,a/=d;
    if(Q.z>Q.x)
      Q.xz=Q.zx;
    if(Q.z>Q.y)
      Q.yz=Q.zy;
    Q.yx*=rotate2D(3.1415/4.);
    return (length(Q.zx)-.03)/a;
  }`